// extracted by mini-css-extract-plugin
export default {"hOMEDiv":"Home_hOMEDiv__N2qaV","button":"Home_button__sTIln","illustration2Icon":"Home_illustration2Icon__QgGEU","homeDiv":"Home_homeDiv__Dpvh8"};